<script>
import Vue from 'vue'
import * as colorHelper from '@/components/shared/color-helper'

export default {
  name: 'AbstractIcon',
  data: () => ({
    white: '#ffffff',
  }),
  computed: {
    primaryColor() {
      const primaryColor = Vue.prototype.$vuetify.theme.themes.light.primary
      return primaryColor || '#0b333b'
    },
    lighterPrimaryColor() {
      return colorHelper.pSBC(0.4, this.primaryColor)
    },
    secondaryColor() {
      const secondaryColor = Vue.prototype.$vuetify.theme.themes.light.warning
      return secondaryColor || '#d7b039'
    },
  },
}
</script>
